// extracted by mini-css-extract-plugin
export default {"CDTIFrameWrapper":"designView-module_CDTIFrameWrapper_vkpEw","CDTIFrame":"designView-module_CDTIFrame_2p4_I"};